import { MediaDeviceFailure } from 'livekit-client';

export type MediaProblem = 'blocked' | 'busy' | 'missing' | 'other';

/** Raison de télémétrie client correspondant à chaque problème de périphérique. */
export const MEDIA_PROBLEM_REASONS = {
  blocked: 'media_permission_denied',
  busy: 'media_device_busy',
  missing: 'media_device_not_found',
} as const;

/** Classe une erreur getUserMedia selon les parcours E-07 (bloqué), E-08 (occupé), E-09 (absent). */
export function classifyMediaError(error: unknown): MediaProblem {
  const failure = MediaDeviceFailure.getFailure(error);
  if (failure === MediaDeviceFailure.PermissionDenied) return 'blocked';
  if (failure === MediaDeviceFailure.DeviceInUse) return 'busy';
  if (failure === MediaDeviceFailure.NotFound) return 'missing';
  return 'other';
}

export const MEDIA_PROBLEM_MESSAGES: Record<MediaProblem, { title: string; body?: string }> = {
  blocked: { title: 'L’accès à la caméra ou au micro est bloqué.' },
  busy: {
    title: 'Votre caméra est utilisée par une autre application.',
    body: 'Fermez-la puis réessayez.',
  },
  missing: { title: 'Aucune caméra détectée.', body: 'Vous pouvez rejoindre sans vidéo.' },
  other: {
    title: 'Impossible d’accéder à la caméra ou au micro.',
    body: 'Vérifiez vos périphériques puis réessayez.',
  },
};
